import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rollback-modal',
  templateUrl: './rollback-modal.component.html',
  styleUrls: ['./rollback-modal.component.css']
})
export class RollbackModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RollbackModalComponent>) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialogRef.close({ action: false });
  }

  onSave() {
    this.dialogRef.close({ action: true });
  }
}
